import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../../../store/context/simple-context";
import Question from "../../Question";
import ComplexTooltip from "./ComplexTooltip";

const SubTitle = ({ complexTooltip, name, tooltip }) => {
  const {
    translate: { t },
  } = useContext(SimpleContext);

  return complexTooltip ? (
    <div className="GP-C-To-N-S">
      <span className="GP-C-To-N-S__frame">{t(name)}</span>
      <Question
        tooltip={<ComplexTooltip name={name} />}
        isComplexContent
        bottomView
      />
    </div>
  ) : (
    <p className="GP-C-To-N-S">
      <span className="GP-C-To-N-S__frame">{t(name)}</span>
      <Question tooltip={t(tooltip)} bottomView />
    </p>
  );
};
SubTitle.propTypes = {
  name: PropTypes.string,
  tooltip: PropTypes.string,
};
export default SubTitle;
